// widths in px
import { StyleProps } from '../../../../utilities'
import {
  STATISTICS_PAGE_STORE,
  STATISTICS_VIEWER_STORE,
  STATISTICS_VIEWERS_TABLE_STORE, StatisticsPageStore, StatisticsViewersTableStore, StatisticsViewerStore
} from '../../../../store'

export const viewersTableWidths = {
  selector: 65,
  draggableColMinWidth: 240,
  tabs: 180,
  expandedTabs: 400,
  totalInteractionTime: 150,
  expandedTotalInteractionTime: 500
}

export type ViewersTableProps = StyleProps & {
  [STATISTICS_VIEWERS_TABLE_STORE]?: StatisticsViewersTableStore
  [STATISTICS_VIEWER_STORE]?: StatisticsViewerStore
  [STATISTICS_PAGE_STORE]?: StatisticsPageStore
}

export const getViewersTableFlexWidth = (columnsCount: number) => {
  return `calc((100% - ${viewersTableTotalWidths.fixedCols
  }px) / ${columnsCount})`
}

// widths in px
export const viewersTableTotalWidths = {
  groupedCols: viewersTableWidths.tabs * 4,
  fixedCols: viewersTableWidths.tabs * 4 + viewersTableWidths.selector
}
